import InputTypesEnum from '../../../Enums/InputTypesEnum';
import PlanningAssignmentService from '../../../Services/PlanningAssignmentService';

class PlanningAssignmentEditItem {
  constructor(selectedItems) {
    this.PricingIds = selectedItems.map((i) => i.PricingId);
    if (selectedItems.length === 1) {
      this.SchedulerUserId = selectedItems[0].SchedulerUserId;
      this.AccountManagerUserId = selectedItems[0].AccountManagerUserId;
    } else {
      this.SchedulerUserId = null;
      this.AccountManagerUserId = null;
    }
  }
}

export default class PlanningAssignmentEditWindowDescription {
  static titleForCreate = 'Edit Scheduler / Account Manager';
  static titleForEdit = 'Edit Scheduler / Account Manager';
  static itemType = PlanningAssignmentEditItem;
  static messageOnSuccess =
    'Assignments saved. The planning grid is now rebuilding in the background and may take a little while — you will get a notification when it is ready.';
  static serviceFunction = async (item) => {
    await PlanningAssignmentService.SetItemAssignment(item.PricingIds, item.SchedulerUserId, item.AccountManagerUserId);
    return true;
  };

  static pagesInGeneralEditWizzard = [
    {
      label: 'Assign',
      fields: [
        {
          fieldName: 'SchedulerUserId',
          label: 'Scheduler',
          className: 'col-6',
          type: InputTypesEnum.UserSelect,
        },
        {
          fieldName: 'AccountManagerUserId',
          label: 'Account Manager',
          className: 'col-6',
          type: InputTypesEnum.UserSelect,
        },
      ],
    },
  ];
}
